import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { GetCurrentUser } from "../../../../../Services/LoginService";
 import { useNavigate } from "react-router-dom";

const AdminHeader = () => {
   const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const result = await GetCurrentUser();

        if (result?.status === "Success") {
          setUser({
            name: result.data.name,
            email: result.data.email,
          });
        }
      } catch (error) {
         if (error.response?.status === 400) {
      navigate("/bad-request", {
        state: {
          error: error.response?.data?.message || "Bad request (400)",
        },
      });
      return;
    }
        console.error("Failed to fetch user:", error.message);
      }
    };

    fetchUser();
  }, []);

  //  Generate initials
  const getInitials = (fullName) => {
    if (!fullName) return "";
    const parts = fullName.trim().split(" ");
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

    return (
      parts[0].charAt(0).toUpperCase() +
      parts[parts.length - 1].charAt(0).toUpperCase()
    );
  };

  const initials = getInitials(user.name);

  return (
    <header className="w-full bg-white shadow-sm px-6 py-3 flex justify-between items-center">
      <h1 className="text-lg font-semibold text-gray-700">
        Welcome to Admin Dashboard,
      </h1>

      <div className="flex items-center gap-4">
        {/* Search Box */}
        <div className="relative">
          <Search className="absolute left-2 top-2 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Search"
            className="pl-8 pr-3 py-1 border border-gray-300 rounded-md text-sm
                       focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        {/* User Info */}
        <div className="flex items-center space-x-3">
          {/* Circle Initials */}
          <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white flex items-center justify-center font-semibold text-sm shadow">
            {initials || "US"}
          </div>

          <div className="hidden md:block">
            <p className="text-sm font-semibold">{user.name || "Loading..."}</p>
            <p className="text-xs text-gray-500">{user.email || ""}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
